/**
 * RequireAdmin - Route guard for the /admin tree. Members (non-admin users)
 * who are signed in get redirected to the member Song Studio (/upload), which
 * is the only part of this app meant for them. The /upload page itself links
 * out to the admin guide on the main site (churchnow.co) for anyone curious
 * about running a church.
 *
 * Admin detection: admin-portal logins always carry userRole 'Admin' and (for
 * multi-church admins) adminChurches; member-context logins of actual admins
 * still surface their membership role. Anyone without an Admin signal is a
 * plain member.
 *
 * Must be used inside ProtectedRoute (user is guaranteed to be non-null).
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export const RequireAdmin: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();

  const isAdmin = user?.userRole === 'Admin' || (user?.adminChurches?.length ?? 0) > 0;

  if (user && !isAdmin) {
    return <Navigate to="/upload" replace />;
  }

  return <>{children}</>;
};
